// extracted by mini-css-extract-plugin
export var content = "_mg-1";
export var divider = "_mg-0";